import React from "react"
import Carousel from "../elements/Carousel"
import CareersSlide from "./CareersSlide"

function CareersCarouselSection({ slides }) {
  const [activeSlide, setActiveSlide] = React.useState(0)
  const careersPageCarouselSettings = {
    arrows: false,
    draggable: true,
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 5000,
    dotsClass: "slick-dots absolute !bottom-2",
    customPaging: (i) => (
      <div
        className={`${
          activeSlide === i ? "bg-secondary" : "bg-white"
        } w-2 h-2 rounded-full`}
      />
    ),
    beforeChange: (current, next) => setActiveSlide(next),
  }

  return (
    <div id="life-at-katch" className={`relative w-full`}>
      <h2 className="text-left text-secondary text-5xl uppercase w-fit mb-12">
        Life at Katch
      </h2>
      <div className="grid grid-cols-1 2xl:grid-cols-8">
        <Carousel
          settings={careersPageCarouselSettings}
          className={
            "h-full md:min-h-400 md:col-span-6 max-h-[300px] overflow-hidden"
          }
        >
          {slides &&
            slides.map((slide, index) => {
              return <CareersSlide key={slide.id} {...slide} />
            })}
        </Carousel>
        <div className="md:col-span-2 font-sans 2xl:px-6 pt-4 2xl:pt-0 space-y-4 w-full">
          {slides && slides[activeSlide] && (
            <>
              <h5 className="font-bold text-2xl ">
                {slides[activeSlide].header}
              </h5>
              <p className="leading-relaxed text-base">
                {slides[activeSlide].body?.body}
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default CareersCarouselSection
